<script setup>
import {ref, onMounted, onBeforeUnmount, watch} from 'vue'
import {Popover} from 'bootstrap'

const props = defineProps({
    tooltip: String,
    title: String,
    show: Number,
    hide: Number,
    trigger: String,
})

const popoverRef = ref(null)
let popoverInstance = null

// --- Methods ---

const initPopover = () => {
    // 1. Dispose of an existing instance if it exists (for prop updates)
    if (popoverInstance) {
        popoverInstance.dispose()
    }

    if (popoverRef.value) {
        // 2. Initialize using the native Bootstrap 5 constructor
        // @ts-ignore - assumes bootstrap is available globally
        popoverInstance = new Popover(popoverRef.value, {
            delay: {
                show: props.show || 0,
                hide: props.hide || 0
            }
        })
    }
}

// --- Lifecycle ---

onMounted(() => {
    initPopover()
})

onBeforeUnmount(() => {
    if (popoverInstance) {
        popoverInstance.dispose()
    }
})

// --- Watchers ---

// Re-initialize if the tooltip content changes dynamically
watch(() => props.tooltip, () => {
    initPopover()
})
</script>

<template>
    <a
        v-if="tooltip"
        ref="popoverRef"
        class="tooltip-anchor"
        tabindex="0"
        role="button"
        :title="title"
        :data-bs-content="tooltip"
        data-bs-container="body"
        data-bs-html="true"
        data-bs-placement="right"
        data-bs-toggle="popover"
        :data-bs-trigger="trigger || 'click'"
    >
        <i class="bi-info-circle-fill"/>
    </a>
</template>


<style scoped>
.tooltip-anchor {
    font-size: 13px;
    color: #bbb;
    cursor: pointer;
    text-decoration: none;
}

.tooltip-anchor:hover {
    color: #999;
}

.tooltip-anchor i {
    color: #aaa;
}

/* Optional: remove blue focus ring on click if desired */
.tooltip-anchor:focus {
    outline: none;
    box-shadow: none;
}
</style>